export const ACCOUNT = 'Account';
export const RECIPIENT = 'Recipient';
export const THIRD_PARTY = 'ThirdParty';
export const COLLECT = 'Collect';
export const OTHERACCOUNT = 'OtherAccount';

export const BillToParty = [ACCOUNT, RECIPIENT, THIRD_PARTY, COLLECT, OTHERACCOUNT];

export const getNameFromOrdinal = (ordinal) => {
  const numericOrdinal = Number.parseInt(ordinal, 10);
  if (Number.isNaN(numericOrdinal)) {
    return RECIPIENT;
  }
  return BillToParty[numericOrdinal];
};
